module.exports = {
	"name": "vam",
	"version": "3.6.9-0",
	"description": "",
	"main": "src/index.js",
	"scripts": {
		"test": "./node_modules/.bin/webpack && ./node_modules/.bin/mocha-phantomjs dist/spec/index.html --reporter xunit --file test-results.xml",
		"start": "webpack-dev-server --content-base dist/",
		"prebid": "cd ./node_modules/prebid.js && npm install && \"./node_modules/.bin/gulp\" build --modules=../../src/header-bidding/prebid-modules.json && cp build/dist/prebid.js ../../dist & cd ../..",
		"build": "./node_modules/.bin/webpack"
	},
	"contributors": [
		"Jose Manuel Ortega <jmortega@vocento.com>",
		"Ernesto V. <evladpereda@ces.vocento.com>",
		"Iván Pérez <ivanperez@vocento.com>"
	],
	"license": "SEE LICENSE IN LICENSE.md",
	"devDependencies": {
		"babel-core": "^6.17.0",
		"babel-eslint": "^8.0.1",
		"babel-loader": "^6.2.5",
		"babel-polyfill": "^6.16.0",
		"babel-preset-es2015": "^6.16.0",
		"chai": "^3.5.0",
		"chalk": "^1.1.3",
		"css-loader": "^0.28.4",
		"eslint": "^4.7.2",
		"eslint-config-airbnb-base": "^12.0.1",
		"eslint-plugin-import": "^2.7.0",
		"extract-text-webpack-plugin": "^1.0.1",
		"html-webpack-plugin": "^2.24.1",
		"json-loader": "^0.5.4",
		"mocha": "^3.1.0",
		"mocha-loader": "^1.0.0",
		"mocha-phantomjs": "^4.1.0",
		"style-loader": "^0.18.2",
		"webpack": "^1.13.3",
		"webpack-shell-plugin": "^0.4.3"
	},
	"dependencies": {
		"prebid.js": "^0.29.0",
		"jquery-inview": "^1.1.2",
		"js-cookie": "^2.1.4",
		"rsvp": "^3.5.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 13
// module chunks = 0 1 3